export { RelatedContentCard } from './RelatedContentCard';
export type { RelatedContentCardProps, RelatedContentItem } from './RelatedContentCard';